import { ReactNode } from "react";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";
import { Font } from "@moneyforward/mfx_biz_react_components";

type Props = {
  header: string;
  children: ReactNode;
};

export const TermBox = (props: Props) => {
  return (
    <div css={container}>
      <Font variant="lb">{props.header}</Font>
      <div css={body}>{props.children}</div>
    </div>
  );
};

const container = css({
  backgroundColor: color.gray50,
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

const body = css({
  border: `solid 1px ${color.gray300}`,
  borderRadius: "4px",
  backgroundColor: color.white,
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  "& ul": {
    margin: 0,
    padding: 0,
    listStyleType: "square",
    listStylePosition: "inside",
    "& li": {
      textIndent: "-1em",
      paddingLeft: "1em",
    },
  },
});
